import { mapValues } from 'lodash'
import { isOwnerField, isSystemField } from '@wix/wix-data-client-common'
import { FieldType } from '@wix/wix-data-schema-types'
import { SEO_FIELD_TYPES } from '../../constants'
import { getPresetSeoFields } from '../../../presets/getPresetSeoFields'

const getSeoDescription = ({ fields, title, presetSeoFields }) => {
  const descriptionFieldName = presetSeoFields.description
  const candidateFields = fields
    .filter(
      ({ name, type }) =>
        name !== title && SEO_FIELD_TYPES.description.includes(type),
    )
    .map(({ name }) => name)

  return candidateFields.includes(descriptionFieldName)
    ? descriptionFieldName
    : candidateFields[0]
}

const getSeoImage = ({ fields, presetSeoFields }) => {
  const imageFieldName = presetSeoFields.image

  const imageFields = fields.filter(({ type }) => type === FieldType.image)
  const image =
    imageFields.find(({ name }) => name === imageFieldName) || imageFields[0]
  return image && image.name
}

export const getSeoValues = ({ collection, editorType, title }) => {
  const presetSeoFields = getPresetSeoFields(editorType)

  const unsortedFields = Object.entries(collection.fields)
    .map(([name, fieldDef]) => ({ ...fieldDef, name }))
    .filter(field => !field.isDeleted && !isOwnerField(field))

  const userFields = unsortedFields.filter(field => !isSystemField(field))
  const systemFields = unsortedFields.filter(isSystemField)
  const fields = [...userFields, ...systemFields]

  const description = getSeoDescription({ fields, title, presetSeoFields })

  const image = getSeoImage({ fields, presetSeoFields })

  return mapValues({ description, image }, value => value && `{${value}}`)
}
